module.exports = __webpack_public_path__ + "media/images/main-bg-1440-639ed51a91f1925920096639b819feb4.png";